import { render, staticRenderFns } from "./detail-potential-customers.vue?vue&type=template&id=09e92813&scoped=true"
import script from "./detail-potential-customers.vue?vue&type=script&lang=js"
export * from "./detail-potential-customers.vue?vue&type=script&lang=js"
import style0 from "./detail-potential-customers.vue?vue&type=style&index=0&id=09e92813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e92813",
  null
  
)

export default component.exports